import { getStaticCustomComponents } from './get-static-custom-components.js'
import { getStaticUiComponents } from './get-static-ui-components.js'
import { TEMPLATE_REGISTRY } from './template-registry.js'
export function getAllComponentNames(): string[] {
  const staticUi = getStaticUiComponents()
  const staticCustom = getStaticCustomComponents()
  const templateKeys = Object.keys(TEMPLATE_REGISTRY)
  return [...new Set([...staticUi, ...staticCustom, ...templateKeys, 'tiptap'])].sort()
}
